import { Stack, Image, FontIcon, Label, ImageFit, PrimaryButton } from '@fluentui/react';
import React, { useContext, useEffect, useState } from 'react';
import styles from '../styles/collectie.module.scss';
import BannerComponent from './bannerComponent';
import GlobalContext from '../_contexts/GlobalContext';

export interface INonNLbannerComponentProps {
    discard: Function;
}

export interface INonNLbannerComponentState {
    moveDown: string;
    content: JSX.Element;
};
  
const NonNLbannerComponent : React.FunctionComponent<INonNLbannerComponentProps> = (props : INonNLbannerComponentProps) => {
    const { OUT_EMAIL, WHATSAPP } = useContext(GlobalContext);

    const content = <div>
                        <Stack horizontal horizontalAlign='center'>
                            <div className={styles.allert}></div>
                        </Stack>
                        <Stack horizontal>
                            <Label style={{marginTop:10}}>We currently only support delivery inside The Netherlands. For orders outsite The Netherlands please contact us for options :&nbsp;</Label>
                            <a href={`mailto:${OUT_EMAIL}`} className={styles.contactUrl} >
                                <FontIcon aria-label="Email" iconName="mail" className={styles.contactImage} 
                                        onClick={() => {window.open(`mailto:${OUT_EMAIL}`);}}/>
                            </a>
                            <Label style={{marginTop:10}}>&nbsp;-&nbsp;</Label>
                            <Image className={styles.whatsappImage} 
                                src={process.env.PUBLIC_URL + `/assets/whatsapp2.webp`} 
                                onClick={() => { window.open(WHATSAPP); }}
                                alt="" imageFit={ImageFit.contain} />
                        </Stack>
                        <Stack horizontal horizontalAlign='center'>
                            <PrimaryButton text='Close' onClick={() => {props.discard();}} />
                        </Stack>
                    </div>;

    return (   
        <BannerComponent content={content} />
    );
}

export default NonNLbannerComponent;